/**
 * 交规
 */

import Base from './Base';

export default class TrafficRules extends Base {
  // doc: https://doc.oschina.net/xingchengzushou?t=219312
  schema = {
    region_id: Number,
    region_name: String,
    article_id: String,
    article_url: String
  };

  static parseInput(obj) {
    return obj;
  }
}



// WEBPACK FOOTER //
// ./src/models/TrafficRules.js